import React from 'react';

const StatsBarsH = (props) => {
	const data = props?.data ?? [];
	const total = props?.total ?? data.length;

	return (
		<ul class="gui_stats_list is_row">
			{data.map((element, i) => {
				const bar_total = element?.total ?? total;
				const percentage = Math.round(element.value * 100 / bar_total);

				let label = element?.name ?? false;
				label += (label !== false) ? ` (${element.value})` : element.value;

				return (
					<li key={i}>
						<p class="stat_label">
							<strong class="cutTextOnOverflow">{label}</strong>

							<span class="value">{`${percentage}%`}</span>
						</p>

						<div class="bar_guide">
							<span class="bar" style={{ width:`${percentage}%` }} />
						</div>
					</li>
				)
			})}
		</ul>
	);
}

export default StatsBarsH;